import React, { useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useTranslation } from "react-i18next";
import { useGeneralContext } from "../../pages/General/Context";
import { comapanyNameToClass } from "../../common/helper";
import { authService } from "../../services/AuthService";
import { useHistory } from "react-router";
import CompanyLogo from "../../components/CompanyLogo/CompanyLogo";
import Search from "./Search";
import "../../pages/styles/navbar.scss";
import Arrow from "../../layout/navbar_icons/left_arrow.svg";
//s
const NavigationBar = ({ isDocOnline, userInfo }) => {
  const { setUserInformation, getUserInfo } = useGeneralContext() || {};
  const { t } = useTranslation();
  const { oktaAuth, authState } = useOktaAuth();
  const { i18n } = useTranslation();
  const [lng, setLng] = useState([]);
  const history = useHistory();

  useEffect(() => {
    if (userInfo.companyLanguages) {
      setLng(userInfo.companyLanguages);
      if (!userInfo.companyLanguages.includes(i18n.language)) {
        i18n.changeLanguage(userInfo.langCode);
      }
    } else {
      setUserInformation(getUserInfo());
    }
  }, [userInfo.companyLanguages]);

  const setLanguage = (evt) => {
    i18n.changeLanguage(evt.target.attributes.value.value);
  };

  const login = async () => {
    oktaAuth.signInWithRedirect("/dashboard");
  };

  const logout = async () => {
    localStorage.removeItem("@vitae/user");
    oktaAuth.signOut({
      postLogoutRedirectUri: window.location.origin + "/goodbye"
    });
    // window.location.href = "https://login.moongy.group/app/UserHome";
  };

  const changeCompany = (companyId) => {
    authService.changeCompany(companyId).then((data) => {
      setUserInformation(data);
      history.push("/dashboard");
      window.location.reload();
    });
  };

  const returnHome = () => {
    history.push("/dashboard");
  };

  const goToHelp = () => {
    history.push("/help");
  };

  const goToUserManagement = () => {
    history.push("/users");
  };

  const goToInterviewSettings = () => {
    history.push("/interviewsettings");
  };

  const goToProposalsSettings = () => {
    history.push("/proposalssettings");
  };

  const goToPermissions = () => {
    history.push("/permissions");
  };

  const goToForgetCandidate = () => {
    history.push("/management/forgetcandidate");
  };

  function beeColorText() {
    if (userInfo.companyAbbreviation === "Bee" || userInfo.companyAbbreviation === "AGAP2IND") {
      return "bee-color-text";
    } else {
      return "";
    }
  }

  return (
    <div
      className={`navbar position-fixed ${comapanyNameToClass(
        userInfo.companyAbbreviation
      )}`}
    >
      <div className="leftmost">
        {userInfo.companyAbbreviation === "RECODME" ||
        userInfo.companyAbbreviation === "Codewin" ||
        userInfo.companyAbbreviation === "GMS" ? (
          <div
            className="logo"
            style={{ marginLeft: "-24px" }}
            onClick={returnHome}
          >
            <CompanyLogo
              company={userInfo.companyAbbreviation}
              height="70px"
              width="auto"
              alt="logo"
            />
          </div>
        ) : (
          <div className="logo" onClick={returnHome}>
            <CompanyLogo
              company={userInfo.companyAbbreviation}
              height="40px"
              width="auto"
              alt="logo"
            />
          </div>
        )}
        <Search company={userInfo.companyAbbreviation} />
      </div>
      <div
        className={`rightmost ${comapanyNameToClass(
          userInfo.companyAbbreviation
        )}`}
      >
        <li className="nav-item dropdown" id="myDropdown">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            data-bs-toggle="dropdown"
          >
            {userInfo !== undefined && (
              <div className="identification" style={{ marginRight: "20px" }}>
                <div>
                  <p
                    className={`name ${beeColorText(
                      userInfo.companyAbbreviation
                    )}`}
                  >
                    {t(userInfo.nickName)}
                  </p>
                  <p
                    className={`position ${beeColorText(
                      userInfo.companyAbbreviation
                    )}`}
                  >
                    {t(userInfo.mainPosition)}
                  </p>
                </div>
                <div
                  className={`nickname-circle ${beeColorText(
                    userInfo.companyAbbreviation
                  )}`}
                >
                  <p
                    className={`${beeColorText(userInfo.companyAbbreviation)}`}
                  >
                    {userInfo.initials}
                  </p>
                </div>
              </div>
            )}
          </a>
          <ul className="dropdown-menu">
            <li>
              <a className="dropdown-item" href="#!">
                <img src={Arrow} alt="arrow" className="left-arrow" />
                <div className="margin-label-language">{t("Language")}</div>
              </a>
              <ul className="submenu dropdown-menu submenu-right">
                {lng !== undefined &&
                  lng.map((item) => (
                    <li>
                      <a
                        className="dropdown-item "
                        href="#!"
                        key={item}
                        value={item}
                        onClick={setLanguage}
                      >
                        {item}
                      </a>
                    </li>
                  ))}
              </ul>
            </li>
            {userInfo.userCompanies?.length > 0 && (
              <li>
                <a className="dropdown-item" href="#!">
                  <img src={Arrow} alt="arrow" className="left-arrow" />
                  <div className="margin-label-company">{t("Companies")}</div>
                </a>
                <ul className="submenu dropdown-menu submenu-right">
                  {userInfo.userCompanies.map((company) => (
                    <li>
                      <a
                        className="dropdown-item"
                        href="#!"
                        key={company.id}
                        value={company.id}
                        onClick={() => changeCompany(company.id)}
                      >
                        {t(company.name)}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            )}
            {(userInfo.permissions?.Permissions_CRUD ||
              userInfo?.permissions?.User_Management_List ||
              userInfo.permissions?.InterviewSettings_List_Quiz ||
              userInfo.permissions?.Interview_Settings_List_Skill ||
              userInfo.permissions?.InterviewSettings_Categories_Sub_List ||
              userInfo.permissions?.ProposalSettings_List_Benefit_Plans) && (
              <li>
                {userInfo?.permissions?.User_Management_List && (
                  <>
                    {" "}
                    <a className="dropdown-item" href="#!">
                      <img src={Arrow} alt="arrow" className="left-arrow" />
                      <div className="margin-label-language">
                        {t("Settings")}
                      </div>
                    </a>
                    <ul className="submenu dropdown-menu submenu-right">
                      <li>
                        <a className="dropdown-item" href="#!">
                          <div>
                            <span
                              className="option-settings"
                              onClick={goToUserManagement}
                            >
                              {t("User Management")}
                            </span>
                          </div>
                        </a>
                      </li>

                      {(userInfo.permissions?.InterviewSettings_List_Quiz ||
                        userInfo.permissions?.Interview_Settings_List_Skill ||
                        userInfo.permissions
                          ?.InterviewSettings_Categories_Sub_List) && (
                        <li>
                          <a className="dropdown-item" href="#!">
                            <div>
                              <span
                                className="option-settings"
                                onClick={goToInterviewSettings}
                              >
                                {t("Interview Settings")}
                              </span>
                            </div>
                          </a>
                        </li>
                      )}
                      {userInfo.permissions
                        ?.ProposalSettings_List_Benefit_Plans && (
                        <li>
                          <a className="dropdown-item" href="#!">
                            <div>
                              <span
                                className="option-settings"
                                onClick={goToProposalsSettings}
                              >
                                {t("Proposals Settings")}
                              </span>
                            </div>
                          </a>
                        </li>
                      )}
                      {userInfo.permissions?.Permissions_CRUD && (
                        <li>
                          <a className="dropdown-item" href="#!">
                            <div>
                              <span
                                className="option-settings"
                                onClick={goToPermissions}
                              >
                                {t("Permissions")}
                              </span>
                            </div>
                          </a>
                        </li>
                      )}
                    </ul>
                  </>
                )}
              </li>
            )}
            <li>
              {userInfo.permissions?.Forget_Candidate_by_Email && (
                <>
                  {" "}
                  <a className="dropdown-item" href="#!">
                    <img src={Arrow} alt="arrow" className="left-arrow" />
                    <div className="margin-label-company">
                      {t("Management")}
                    </div>
                  </a>
                  <ul className="submenu dropdown-menu submenu-right">
                    <li>
                      <a className="dropdown-item" href="#!">
                        <div>
                          <span
                            className="option-settings"
                            onClick={goToForgetCandidate}
                          >
                            {t("Forget Candidate")}
                          </span>
                        </div>
                      </a>
                    </li>
                  </ul>
                </>
              )}
            </li>
            <li>
              <a className="dropdown-item" href="/help">
                <div>
                  <a>
                    <span className="help-button" onClick={goToHelp}>
                      {t("Help")}
                    </span>
                  </a>
                </div>
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="#">
                <div>
                  {!isDocOnline && authState && authState.isAuthenticated && (
                    <a>
                      <span onClick={logout} className="width-button-logout">
                        {t("Logout")}
                      </span>
                    </a>
                  )}
                  {!isDocOnline && authState && !authState.isAuthenticated && (
                    <a>
                      <span onClick={login}>
                        <div>Login</div>
                      </span>
                    </a>
                  )}
                </div>
              </a>
            </li>
          </ul>
        </li>
      </div>
    </div>
  );
};

export default NavigationBar;
